import React, { Component } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { format } from "date-fns";
import Takeover from '../takeover';
import SpinnerDots from '../spinner/dots';
import { ButtonComponent } from '../../components/export-btn';
import { REACT_APP_API_BASE } from '../../config';
import './styles.scss';

class Events extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            tabId: 1,
            newUnitsExportIsOpen: false,
            deletedUnitsExportIsOpen: false,
            selectedExportFormat: ''
        }
    
    }

    componentDidUpdate(prevProps) {
        if (this.props.unitUpdates && !prevProps.unitUpdates) {
            this.setState({
                tabId: this.props.unitUpdates.userIsAllowedToSeeUnitUpdates ? 1 : 3
            });
        }
    }
    
    changeTab(tabId) {
        this.setState({
            tabId
        });
    }

    toggleNewUnitsExport() {
        this.setState({
            newUnitsExportIsOpen: !this.state.newUnitsExportIsOpen
        });
    }

    toggleDeletedUnitsExport() {
        this.setState({
            deletedUnitsExportIsOpen: !this.state.deletedUnitsExportIsOpen
        });
    }

    sortUnits(units) {
        const compare = ( a, b ) => {
            const dateA = new Date(a.LastChanged);
            const dateB = new Date(b.LastChanged);

            if ( dateA < dateB ){
              return -1;
            }
            if ( dateA > dateB ){
              return 1;
            }

            return 0;
        }
          
        units.sort(compare);
        
        return units.reverse();
    }

    getMimeType(format) {
        switch (format) {
            case 'excel':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'xml':
                return 'application/xml';
            case 'csv':
                return 'text/csv';
            default:
                return '';
        }
    }

    getFileFormat(format) {
        switch (format) {
            case 'excel':
                return 'xlsx';
            case 'xml':
                return 'xml';
            case 'csv':
                return 'csv';
            default:
                return '';
        }
    }

    setSelectedExportFormat(selectedExportFormat) {
        this.setState({
            selectedExportFormat
        });
    }

    getExportStateText() {
        if (this.state.isExporting) {
            return 'Exporterar enheter';
        }

        if (this.state.isExportingFinished) {
            return 'Klar!';
        }

        return 'Exportera enheter';
    }

    async exportResult(type) {
        if (this.state.selectedExportFormat === '') return;
        
        this.setState({
            isExporting: true
        });

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/units/${type}/export?format=${this.state.selectedExportFormat}`);
        
        if (res.ok) {
            const exportReport = await res.blob();
            var blob = new Blob([exportReport], { type: this.getMimeType(this.state.selectedExportFormat) });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = type === 'new' ? `Nya enheter.${this.getFileFormat(this.state.selectedExportFormat)}` : `Nedlagda enheter.${this.getFileFormat(this.state.selectedExportFormat)}`;
            link.click();

            this.setState({
                isExporting: false,
                isExportingFinished: true
            });

            setTimeout(() => {
                this.setState({
                    isExportingFinished: false
                });
                this.setSelectedExportFormat('');

            }, 4000);
        }
    }
    
    render() {
        return (
            <section className={classNames({
                'events': true,
                'events--is-loading': this.props.isLoading
            })}>
                <div className="events__wrapper">
                    <header className="events__header">
                        <h1 className="events__heading">Händelser</h1>
                        {this.props.unitUpdates &&
                            <>
                                <ul className="events__nav">
                                    {this.props.unitUpdates.userIsAllowedToSeeUnitUpdates &&
                                        <>
                                            <li>
                                                <button onClick={() => this.changeTab(1)} type="button" className={classNames({
                                                    'events__nav-item': true,
                                                    'events__nav-item--selected': this.state.tabId === 1
                                                })}>Nya enheter</button>
                                            </li>
                                            <li>
                                                <button onClick={() => this.changeTab(2)} type="button" className={classNames({
                                                    'events__nav-item': true,
                                                    'events__nav-item--selected': this.state.tabId === 2
                                                })}>Nedlagda enheter</button>
                                            </li>
                                        </>
                                    }
                                    <li>
                                        <button onClick={() => this.changeTab(3)} type="button" className={classNames({
                                            'events__nav-item': true,
                                            'events__nav-item--selected': this.state.tabId === 3
                                        })}>Nyheter</button>
                                    </li>
                                </ul>
                            </>
                        }
                    </header>
                    <div className="events__content">
                        {this.props.unitUpdates && this.props.unitUpdates.userIsAllowedToSeeUnitUpdates &&
                            <div className="events__table">
                                {this.state.tabId === 1 && 
                                    <>
                                        {this.props.unitUpdates && this.props.unitUpdates.newUnits.length > 0 &&
                                            <>
                                                <div className="events__table-inner">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>ENHET</th>
                                                                <th>DELFI-ID</th>
                                                                <th>TYP</th>
                                                                <th>GATA</th>
                                                                <th>ORT</th>
                                                                <th>STATUS</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.props.unitUpdates && this.sortUnits(this.props.unitUpdates.newUnits).map(unit => {                                                           
                                                                return (
                                                                    <tr key={`new${unit.DelfiId}`}>
                                                                        <td><Link to={`/unit/${unit.DelfiId}`}>{unit.UnitName}</Link></td>
                                                                        <td>{unit.DelfiId}</td>
                                                                        <td>{unit.TypeGroupName}</td>
                                                                        <td>{unit.PostalAddress.Address}</td>
                                                                        <td>{unit.PostalAddress.City}</td>
                                                                        <td>Ny</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {this.props.menu && this.props.menu.allowedToExportUnits &&
                                                    <>
                                                        <button type="button" className="events__export-button" onClick={() => this.toggleNewUnitsExport()}>Exportera</button>
                                                
                                                    

                                                        <Takeover isOpen={this.state.newUnitsExportIsOpen} toggleTakeover={() => {
                                                            this.setSelectedExportFormat('');
                                                            this.toggleNewUnitsExport()}} heading="Exportera nya enheter">
                                                            <div>
                                                                <p>
                                                                    Följande data ({this.props.unitUpdates.newUnits.length} st enheter) kommer att exporteras, kostnaden för detta blir för er med: 
                                                                </p>
                                                                <ul>
                                                                    <li>Abo Plus (abonnemang med uppdatering) - fria uttag</li>
                                                                    <li>Abo Bas (abonnemang utan uppdatering) - 3 kronor per enhet</li>
                                                                </ul>
                                                                <p>
                                                                    Är ni osäkra på vilket alternativ som gäller för Er kontrollera ert
                                                                    abonnemang alt. kontakta oss på Delfi tel. 08-522 243 00.
                                                                </p>

                                                                <div className={classNames({
                                                                    'export-raw': true,
                                                                    'export-raw--exporting': this.state.isExporting,
                                                                    'export-raw--is-finished': this.state.isExportingFinished
                                                                })}>
                                                                    <div className="export-raw__content">
                                                                        <label className="export-raw__select-lbl">
                                                                            <select className="export-raw__select" onChange={(e) => this.setSelectedExportFormat(e.currentTarget.value)} value={this.state.selectedExportFormat}>
                                                                                <option value="">Välj filformat</option>
                                                                                <option value="excel">Excel</option>
                                                                                <option value="csv">CSV</option>
                                                                                <option value="xml">XML</option>
                                                                            </select>
                                                                        </label>
                                                                        <ButtonComponent onClick={() => this.exportResult('new')} text={this.getExportStateText()} disabled={this.state.selectedExportFormat === ''} />
                                                                        <button className="export-raw__close" type="button" onClick={() => {
                                                                                this.setSelectedExportFormat('');
                                                                                this.toggleNewUnitsExport();
                                                                            }}>Avbryt</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Takeover>
                                                    </>
                                                }

                                            </>
                                        }
                                        {this.props.unitUpdates && this.props.unitUpdates.newUnits.length === 0 &&
                                            <p className="events__no-hits">🏠 Det finns inga nya enheter.</p>
                                        }
                                    </>
                                }

                                {this.state.tabId === 2 &&
                                    <>
                                        {this.props.unitUpdates && this.props.unitUpdates.deletedUnits.length > 0 &&
                                            <>
                                                <div className="events__table-inner">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>ENHET</th>
                                                                <th>DELFI-ID</th>
                                                                <th>TYP</th>
                                                                <th>GATA</th>
                                                                <th>ORT</th>
                                                                <th>STATUS</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.props.unitUpdates && this.sortUnits(this.props.unitUpdates.deletedUnits).map(unit => {
                                                                return (
                                                                    <tr key={`new${unit.DelfiId}`}>
                                                                        <td><Link to={`/unit/${unit.DelfiId}`}>{unit.UnitName}</Link></td>
                                                                        <td>{unit.DelfiId}</td>
                                                                        <td>{unit.TypeGroupName}</td>
                                                                        <td>{unit.PostalAddress.Address}</td>
                                                                        <td>{unit.PostalAddress.City}</td>
                                                                        <td>Nedlagd</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {this.props.menu && this.props.menu.allowedToExportUnits &&
                                                    <>
                                                        <button type="button" className="events__export-button" onClick={() => this.toggleDeletedUnitsExport()}>Exportera</button>

                                                        <Takeover isOpen={this.state.deletedUnitsExportIsOpen} toggleTakeover={() => {
                                                            this.setSelectedExportFormat('');
                                                            this.toggleDeletedUnitsExport()}} heading="Exportera nedlagda enheter">
                                                            <div>
                                                                <p>
                                                                    Följande data ({this.props.unitUpdates.deletedUnits.length} st enheter) kommer att exporteras, kostnaden för detta blir för er med: 
                                                                </p>
                                                                <ul>
                                                                    <li>Abo Plus (abonnemang med uppdatering) - fria uttag</li>
                                                                    <li>Abo Bas (abonnemang utan uppdatering) - 3 kronor per enhet</li>
                                                                </ul>
                                                                <p>
                                                                    Är ni osäkra på vilket alternativ som gäller för Er kontrollera ert
                                                                    abonnemang alt. kontakta oss på Delfi tel. 08-522 243 00.
                                                                </p>

                                                                <div className={classNames({
                                                                    'export-raw': true,
                                                                    'export-raw--exporting': this.state.isExporting,
                                                                    'export-raw--is-finished': this.state.isExportingFinished
                                                                })}>
                                                                    <div className="export-raw__content">
                                                                        <label className="export-raw__select-lbl">
                                                                            <select className="export-raw__select" onChange={(e) => this.setSelectedExportFormat(e.currentTarget.value)} value={this.state.selectedExportFormat}>
                                                                                <option value="">Välj filformat</option>
                                                                                <option value="excel">Excel</option>
                                                                                <option value="csv">CSV</option>
                                                                                <option value="xml">XML</option>
                                                                            </select>
                                                                        </label>
                                                                        <ButtonComponent onClick={() => this.exportResult('deleted')} text={this.getExportStateText()} disabled={this.state.selectedExportFormat === ''} />
                                                                        <button className="export-raw__close" type="button" onClick={() => {
                                                                                this.setSelectedExportFormat('');
                                                                                this.toggleNewUnitsExport();
                                                                            }}>Avbryt</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Takeover>
                                                    </>
                                                }
                                            </>
                                        }

                                        {this.props.unitUpdates && this.props.unitUpdates.deletedUnits.length === 0 &&
                                            <p className="events__no-hits">🏚 Det finns inga nedlagda enheter.</p>
                                        }
                                    </>
                                }
                            </div>
                        }

                        {this.state.tabId === 3 &&
                            <div className="events__news">
                                <div className="events__news-list">
                                    {this.props.news && this.props.news.map(item => {
                                        return (
                                            <div className="events__news-item" key={item.newsId}>
                                                <div className="events__news-item-date">{format(new Date(item.publishedOn),'yyyy-MM-dd')}</div>
                                                <Link className="events__news-item-link" to={`/news/${item.slug}`}>{item.header}</Link>
                                            </div>
                                        );
                                    })}
                                </div>
                                <Link className="events__news-link" to="/news">Alla nyheter</Link>
                            </div>
                        } 
                        <SpinnerDots />   
                    </div>
                </div>
            </section>
        );
    }
    
};

export default Events;